import useQuery from "../../../hooks/useQuery";

const useParameters = ()=>{
    const {animal_location, case_num} = useQuery();
    return {animal_location, case_num};
}

export default useParameters;